// extracted by mini-css-extract-plugin
module.exports = {"baseArticle":"Article_baseArticle__h3Eie","article":"Article_article__Ed6Sz","tiledHomePageArticle":"Article_tiledHomePageArticle__3hDyo"};